import React from 'react';

const SvgCalendarDay = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || '14'}
    height={props.height || '17'}
    viewBox="0 0 14 17"
    fill="none"
    {...props}
  >
    <path
      d="M0 14.96C0 15.7881 0.671875 16.46 1.5 16.46H12.5C13.3281 16.46 14 15.7881 14 14.96V6.45996H0V14.96ZM2 8.95996C2 8.68496 2.225 8.45996 2.5 8.45996H5.5C5.775 8.45996 6 8.68496 6 8.95996V11.96C6 12.235 5.775 12.46 5.5 12.46H2.5C2.225 12.46 2 12.235 2 11.96V8.95996ZM12.5 2.45996H11V0.959961C11 0.684961 10.775 0.459961 10.5 0.459961H9.5C9.225 0.459961 9 0.684961 9 0.959961V2.45996H5V0.959961C5 0.684961 4.775 0.459961 4.5 0.459961H3.5C3.225 0.459961 3 0.684961 3 0.959961V2.45996H1.5C0.671875 2.45996 0 3.13184 0 3.95996V5.45996H14V3.95996C14 3.13184 13.3281 2.45996 12.5 2.45996Z"
      fill={props.color || 'white'}
    />
  </svg>
);

export default SvgCalendarDay;
